import { Component, Input, OnChanges, OnDestroy } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent, TableComponent as LibTableComponent, PaginationParam, TableColumn, tableSortEvent, TableSummary } from 'daisy-design-system-front';
import { FormGroup, FormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { StationTagsConfiguration } from './station-tags-configuration';
import { OntologyFormType } from '@gnv-shared/types';
import { TooltipModule } from 'primeng/tooltip';
import { selectStationsByUids } from '../../../../../store/stations/stations.selectors';

@Component({
  selector: "app-tag-writer",
  templateUrl: "./tag-writer.component.html",
  styleUrls: ["./tag-writer.component.scss"],
  standalone: true,
  imports: [
    FormsModule,
    TranslateModule,
    LibTableComponent,
    TooltipModule
],
})
export class TagWriterComponent implements OnChanges, OnDestroy {
  @Input() stationUids: string[] = [];
  @Input() valueFormGroup!: FormGroup<OntologyFormType>;

  public tableSummary!: TableSummary;
  public tableColumns!: TableColumn[];

  private viewSub$!: Subscription;

  constructor(
    private readonly stationTagsConfiguration: StationTagsConfiguration,
    private readonly store: Store,
  ) {
    this.tableColumns = this.stationTagsConfiguration.getTableColumns();
  }

  ngOnChanges(): void {
    this.stationTagsConfiguration.valueFormGroup = this.valueFormGroup
    this.buildStations();
  }

  private buildStations() {
    this.viewSub$ = this.store.select(selectStationsByUids(this.stationUids))
      .subscribe(stationSummaries => {
        this.tableSummary = {rows: stationSummaries}
      });
  }

  onPageChange($event: PaginationParam) {
  }

  onGlobalSearch($event: string) {
  }

  onSortChange($event: tableSortEvent) {
  }

  onRefresh() {
  }

  onRowExpand($event: any) {
  }

  ngOnDestroy(): void {
    this.viewSub$?.unsubscribe();
  }

}
